import React from 'react';
import { useIntl } from 'react-intl';
import { TypedMemo } from '../../../common/types';
import { aiNoticeMessages } from '../aiNotice/aiNoticeMessages';
import type { CalendarPost } from '../types';
import { withBrandWord } from '../../components/primitives/BrandWord';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for the panel; each part uses its own slice of it */
import styles from './DayPanel.module.scss';
/* eslint-enable css-modules/no-unused-class */

interface PostAiNoteProps {
  post: Pick<CalendarPost, 'containsAiVideo' | 'status'>;
}

/**
 * The fixed AI notice of the post sheet: the media of the post holds AI-generated footage. A post
 * that waits for the artist ("needs you") also says that the artist must turn the label on.
 */
const PostAiNoteComponent: React.FC<PostAiNoteProps> = ({ post }) => {
  const intl = useIntl();
  if (post.containsAiVideo !== true) {
    return null;
  }
  return (
    <div className={styles.dpBody} role="note" data-testid="post-ai-note">
      <span className={styles.tiny}>{withBrandWord(intl.formatMessage(aiNoticeMessages.text))}</span>
      {post.status === 'awaitingManualPost' ? (
        <span className={styles.tiny} data-testid="post-ai-note-manual">
          {intl.formatMessage(aiNoticeMessages.manual)}
        </span>
      ) : null}
    </div>
  );
};

export const PostAiNote = TypedMemo(PostAiNoteComponent);
